import { render, staticRenderFns } from "./DesempenhoPorEquipe.vue?vue&type=template&id=7f966f49"
import script from "./DesempenhoPorEquipe.vue?vue&type=script&lang=js"
export * from "./DesempenhoPorEquipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports